module.exports = __webpack_public_path__ + "static/media/05_Portfolio.4bac9aa0.png";